import React, { useEffect } from 'react';
import { useAppState } from 'oasis-os-react';
import './style.css';

type GapBgProps = {
  [key: string]: string;
};

type StyleProps = Record<string, string>;

const GapFiller = () => {
  const [, , app] = useAppState();

  const [gapFillerProps, setgapFillerProps] = React.useState<{ show: boolean; style: StyleProps }>({
    show: false,
    style: {},
  });

  useEffect(() => {
    app.registerAction('navigationGapBg', (show: boolean, styleProps: GapBgProps) => {
      const style: StyleProps = {
        ...styleProps,
      };
      setgapFillerProps({ show, style });
    });
  }, []);

  return (
    <>
      {gapFillerProps?.show ? (
        <div
          className="pwa__side-nav__gap-filler"
          style={{ ...gapFillerProps.style }}
          data-testid="pwa-sidenav-gap-filler"
        ></div>
      ) : null}
    </>
  );
};

export default GapFiller;
